<template>
    <div class="banner flexColumn">
        <Grid
            :GridStyle="{
                'grid-template-columns': 'repeat(10, 1fr)',
                'grid-template-rows': 'repeat(3, 1fr)',
                'font-size': '0.14rem',
                'grid-column': '1 / span 6',
                'height': '10%',
                'border': '1px solid #02d9fd',
                'background': '#02d9fd'
            }"
            :gridDatas="{
                data: performenceData,
                settings: {
                0: {
                    'grid-row': '1 / span 1',
                    'grid-column': '1 / span 5'
                },
                1: {
                    'grid-row': '1 / span 1',
                    'grid-column': '6 / span 5'
                },
                2: {
                    'grid-row': '2 / span 1',
                    'grid-column': '1 / span 1'
                },
                3: {
                    'grid-row': '2 / span 1',
                    'grid-column': '2 / span 1'
                },
                4: {
                    'grid-row': '2 / span 1',
                    'grid-column': '3 / span 3'
                },
                5: {
                    'grid-row': '2 / span 1',
                    'grid-column': '6 / span 1'
                },
                6: {
                    'grid-row': '2 / span 1',
                    'grid-column': '7 / span 1'
                },
                7: {
                    'grid-row': '2 / span 1',
                    'grid-column': '8 / span 3'
                },
                8: {
                    'grid-row': '3 / span 1',
                    'grid-column': '1 / span 1'
                },
                9: {
                    'grid-row': '3 / span 1',
                    'grid-column': '2 / span 1'
                },
                10: {
                    'grid-row': '3 / span 1',
                    'grid-column': '3 / span 3'
                },
                11: {
                    'grid-row': '3 / span 1',
                    'grid-column': '6 / span 1'
                },
                12: {
                    'grid-row': '3 / span 1',
                    'grid-column': '7 / span 1'
                },
                13: {
                    'grid-row': '3 / span 1',
                    'grid-column': '8 / span 3'
                },
                }
            }"
        />
        <div class="bottomBox">
            <box-border
                title="风险跟踪"
                :boxStyle="{
                    'grid-column': '1 / span 2'
                }"
            >
                <echart-module
                    ref="riskTrack"
                    :option="riskTrack"
                    style="height: 100%;width: 100%;"
                ></echart-module>
            </box-border>
            <box-border
                title="HSE Activities"
                :boxStyle="{
                    'grid-column': '3 / span 2'
                }"
            >
                <echart-module
                    ref="Activities"
                    :option="Activities"
                    style="height: 100%;width: 100%;"
                ></echart-module>
            </box-border>
            <box-border
                title="Resume of HSE Events"
                :boxStyle="{
                    'grid-column': '5 / span 2'
                }"
            >
                <echart-module
                    ref="HSEEvents"
                    :option="HSEEvents"
                    style="height: 100%;width: 100%;"
                ></echart-module>
            </box-border>
            <box-border
                title="NCR Status"
                :boxStyle="{
                    'grid-column': '1 / span 2'
                }"
            >
                <echart-module
                    ref="NCRStatus"
                    :option="NCRStatus"
                    style="height: 100%;width: 100%;"
                ></echart-module>
            </box-border>
            <box-border
                title="CARs Status"
                :boxStyle="{
                    'grid-column': '3 / span 2'
                }"
            >
                <echart-module
                    ref="CARsStatus"
                    :option="CARsStatus"
                    style="height: 100%;width: 100%;"
                ></echart-module>
            </box-border>
            <box-border
                title="QA/QC KPI"
                :boxStyle="{
                    'grid-column': '5 / span 2'
                }"
            >
                <echart-module
                    ref="QAQCKPI"
                    :option="QAQCKPI"
                    style="height: 100%;width: 100%;"
                ></echart-module>
            </box-border>
        </div>
        
    </div>
</template>
<script>
    import { servedetail2UsingPOST } from '@/api/dataapi'
    import { mapActions } from 'vuex';
    export default{
        name: 'QHSE',
        data(){
            return {
                performenceData: ['员工', '分包商', '中国', '乌干达', '人工时', '中国', '乌干达', '人工时'],
                riskTrack: {
                    grid: {
                        top: '15%',
                        bottom: '5%',
                        right: '2%'
                    },
                    color: [1, 0, 3]
                },
                Activities: {
                    grid: {
                        top: '15%',
                        bottom: '5%',
                        right: '2%'
                    },
                    color: [1, 0]
                },
                NCRStatus: {
                    clickFn: () => {
                        //按公司
                        this.getNewVTos({
                            id: '2c92808382d8cbaa0182d9ea37820007',
                            stype: 0
                        },
                        [
                            ['本周'],
                            ['bar']
                        ],
                        this.$refs.NCRStatus.myChart,
                        {
                            name: 'NCRStatus',
                            label: true
                        }
                        )
                    },
                    grid: {
                        top: '15%',
                        bottom: '5%',
                        right: '2%'
                    },
                    color: [1, 0],
                    tooltip: {
                        formatter: function(datas){
                            let html = `${datas[0].axisValue} <br />`;
                            datas.forEach((item, index) => {
                                if(typeof item.value === 'number'){
                                    html += (item.marker + item.seriesName + '&nbsp;&nbsp;' + item.value + '<br/>')
                                }
                                if(index > 0){
                                    item.data.s3.replaceAll(/\s/g, '') && (html += `<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:#FFFFFF;"></span>Overdue&nbsp;&nbsp;${item.data.s3}<br/>`)
                                }
                            })
                            return html;
                        }
                    },
                    toolbox: {
                        show: true,
                        feature: {
                            myTool1: {
                                iconStyle: {
                                    borderColor: '#fff'
                                },
                                show: true,
                                title: '返回',
                                icon: 'path://M700.371228 394.525472 174.028569 394.525472l255.952416-227.506551c12.389168-11.011798 13.505595-29.980825 2.492774-42.369993-11.011798-12.386098-29.977755-13.506619-42.367947-2.492774L76.425623 400.975371c-6.960529 5.496178-11.434423 14.003945-11.434423 23.561625 0 0.013303 0.001023 0.026606 0.001023 0.039909 0 0.01228-0.001023 0.025583-0.001023 0.037862 0 0.473791 0.01535 0.946558 0.037862 1.418302 0.001023 0.016373 0.001023 0.032746 0.001023 0.049119 0.39295 8.030907 3.992941 15.595186 10.034541 20.962427l315.040163 280.028764c5.717212 5.083785 12.83533 7.580652 19.925818 7.580652 8.274454 0 16.514115-3.403516 22.442128-10.07445 11.011798-12.387122 9.896394-31.357172-2.492774-42.367947l-256.128425-227.665163 526.518668 0c109.219517 0 198.075241 88.855724 198.075241 198.075241s-88.855724 198.075241-198.075241 198.075241L354.324888 850.696955c-16.57449 0-30.011524 13.437034-30.011524 30.011524s13.437034 30.011524 30.011524 30.011524l346.046341 0c142.31631 0 258.098289-115.783003 258.098289-258.098289S842.686515 394.525472 700.371228 394.525472z',
                                onclick: () => {
                                    //返回
                                    this.getNewVTos({
                                        id: '2c92808382d8cbaa0182d9e9d8770006',
                                        stype: 0
                                    },
                                    [
                                        ['累计', '本周'],
                                        ['bar', 'bar']
                                    ],
                                    this.$refs.NCRStatus.myChart,
                                    {
                                        name: 'NCRStatus',
                                        hasMoreData: ['s3'],
                                        label: true
                                    }
                                    )
                                }
                            },
                        }
                    },
                },
                CARsStatus: {
                    grid: {
                        top: '15%',
                        bottom: '5%',
                        right: '2%'
                    },
                    color: [1, 0],
                    tooltip: {
                        formatter: function(datas){
                            let html = `${datas[0].axisValue} <br />`;
                            datas.forEach((item, index) => {
                                if(typeof item.value === 'number'){
                                    html += (item.marker + item.seriesName + '&nbsp;&nbsp;' + item.value + '<br/>')
                                }
                                if(index > 0){
                                    item.data.s3.replaceAll(/\s/g, '') && (html += `<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:#FFFFFF;"></span>Overdue&nbsp;&nbsp;${item.data.s3}<br/>`)
                                }
                            })
                            return html;
                        }
                    },
                },
                QAQCKPI: {
                    grid: {
                        top: '15%',
                        bottom: this.fontSizeFn(35),
                        right: '2%'
                    },
                    color: [0, 5],
                    legend: {
                        top: '0%'
                    },
                    xAxis: {
                        interval: 0
                    }
                },
                HSEEvents: {
                    color: [0,1,2,3,4],
                    grid: {
                        top: '15%',
                        bottom: '5%',
                        right: '2%'
                    },
                    legend: {
                        show: false
                    },
                    tooltip: {
                        trigger: 'item',
                        formatter: (params) => {
                            const data = params.data;
                            let html = `${params.name} <br />`;
                            html += `本周: ${data.s2}<br/>`;
                            html += `本月: ${data.s3}<br/>`;
                            html += `累计: ${data.s4}<br/>`;
                            return html;
                        }
                    },
                }
            }
        },
        methods: {
            ...mapActions(['OPEN_TABLEBOX_DATAS'])
        },
        mounted() {
            const xhrArr = [
                //Statistics
                async () => {
                    const datas = await servedetail2UsingPOST({
                        dataDetails: [
                            { chartid: '2c92808f828168cf018290d994070043', dataindex: 0, stype: 0 }
                        ], modulename: 'uganda'
                    });
                    datas.forEach(item => {
                        for(let i = 1; i < 7; i++){
                            this.$nextTick(() => {
                                this.performenceData.push(item['v' + i])
                            })
                        }
                    })
                },
                //riskTrack
                async () => {
                    this.getNewVTos(
                        {
                            id: '2c92808382ee082a0182fd32b8740023',
                            stype: 0
                        },
                        [
                            ['未开始', '进行中', '已关闭'],
                            ['bar', 'bar', 'bar']
                        ],
                        this.$refs.riskTrack.myChart,
                        {
                            name: 'riskTrack',
                            stack: true,
                            label: true,
                            clickFn: async(params) => {
                                //弹出表格
                                const data = await this.getTableData('2c92808382ee082a0182fd3470750024', params.name);
                                this.OPEN_TABLEBOX_DATAS(data);
                            }
                        }
                    )
                },
                //Activities
                async () => {
                    this.getNewVTos({
                        id: '2c92808382d8cbaa0182d9e9224a0004',
                        stype: 0
                    },
                    [
                        ['本周', '本月'],
                        ['bar', 'bar']
                    ],
                    this.$refs.Activities.myChart,
                    {
                        name: 'Activities',
                        label: true
                    }
                    )
                },
                //HSEEvents
                async () => {
                    this.getFunnel({
                        id: '2c92808382d8cbaa0182d9e97e430005',
                        stype: 0
                    },
                    {
                        name: 'HSEEvents',
                        valueKey: 's1',
                        hasMoreData: ['s2', 's3', 's4'],
                        seriesName: '',
                        labelStyle: {
                            formatter: (params) => {
                                const data = params.data;
                                return `${data.name} (${data.s2} / ${data.s3} / ${data.s4})`
                            }
                        },
                        chart: this.$refs.HSEEvents.myChart,
                        otherStyle: {
                            emphasis: {
                                label: {
                                    fontSize: this.fontSizeFn(24)
                                }
                            },
                        }
                    }
                    )
                },
                //NCRStatus
                async () => {
                    this.getNewVTos({
                        id: '2c92808382d8cbaa0182d9e9d8770006',
                        stype: 0
                    },
                    [
                        ['累计', '本周'],
                        ['bar', 'bar']
                    ],
                    this.$refs.NCRStatus.myChart,
                    {
                        name: 'NCRStatus',
                        hasMoreData: ['s3'],
                        label: true
                    }
                    )
                },
                //CARsStatus
                async () => {
                    this.getNewVTos({
                        id: '2c92808382d8cbaa0182d9ea7e330008',
                        stype: 0
                    },
                    [
                        ['累计', '本周'],
                        ['bar', 'bar']
                    ],
                    this.$refs.CARsStatus.myChart,
                    {
                        name: 'CARsStatus',
                        hasMoreData: ['s3'],
                        label: true
                    }
                    )
                },
                //QAQCKPI
                async () => {
                    this.getNewVTos({
                        id: '2c92808382d8cbaa0182d9eac8be0009',
                        stype: 0
                    },
                    [
                        ['数量', '目标'],
                        ['bar', 'line']
                    ],
                    this.$refs.QAQCKPI.myChart,
                    {
                        name: 'QAQCKPI'
                    }
                    )
                }

            ];
            this.getAllPromise(xhrArr)
        },
    }
</script>
<style scoped lang="less">
    .banner{
        padding-top: 0.24rem;
    }
    .bottomBox{
        height: 86.5%;
        .gridStyle(6, 2, 0.24rem, 0.1rem);
    }
</style>